export interface TaskRow {
  id: number;
  user_id?: number | null;
  von?: number;
  titel?: string;
  beschreibung?: string;
  datum?: string | null;
  erinnerung?: string | null;
  zieldatum?: string | null;
  status?: number;
  /** Priorität: 0 = Normal, 1 = Hoch (Alarm-Rot). */
  priority?: number;
  created_at?: string;
  /** Batch-12: zugewiesene Bearbeiter (Admin-IDs) — wie im Kundendashboard. */
  bearbeiter?: number[] | null;
  /** Batch-13 Paket E — nur im Konto-Modus (accountId gesetzt) vorhanden. */
  account_id?: number | null;
  /** Anzeigename der zugeordneten Person, oder null (kein Personenbezug). */
  user_name?: string | null;
}

export interface NoticeRow {
  id: number;
  user_id?: number | null;
  von?: number;
  /** Erstellende:r Mitarbeiter:in (Recht „Anpinnen" für Rolle Mitarbeiter). */
  admin_id?: number | null;
  comment?: string;
  nachricht?: string;
  text?: string;
  created_at?: string;
  /** Gepinnte Notizen stehen oben (v1 liefert 0/1, v2 boolean oder 0/1). */
  pinned?: number | boolean | null;
  /** Batch-13 Paket E — nur im Konto-Modus (accountId gesetzt) vorhanden. */
  account_id?: number | null;
  user_name?: string | null;
}

/**
 * Sortierregel für Notizen (Batch-13): gepinnte zuerst, danach neueste
 * zuerst nach `created_at`. Spiegelt die Server-Sortierung des v2-Endpoints
 * und deckt den v1-Pfad ab, der unsortiert liefert.
 */
export function sortNotices<T extends NoticeRow>(rows: readonly T[]): T[] {
  const ts = (v?: string) => {
    const t = v ? Date.parse(v) : NaN;
    return Number.isNaN(t) ? 0 : t;
  };
  return [...rows].sort((a, b) => {
    const pa = a.pinned ? 1 : 0;
    const pb = b.pinned ? 1 : 0;
    if (pa !== pb) return pb - pa;
    const d = ts(b.created_at) - ts(a.created_at);
    if (d !== 0) return d;
    return b.id - a.id;
  });
}

/** Personen-Option für die Auswahl in TaskForm/NoticeForm (Batch-13 Paket E). */
export interface PersonOption {
  user_id: number;
  name: string;
}
